data class SpringConnection1D(val index: Int, val restLength: Double)
typealias SpringConnections = List<SpringConnection1D>
fun createSpringConnection1D(sp: List<SpringParticle>): List<SpringConnections> {
    return mutableListOf<SpringConnections>().apply {
        val depth = 50
        val skip = mutableListOf<Int>()
        sp.forEachIndexed { i, p ->
            val connections = mutableListOf<SpringConnection1D>()
            repeat(depth){ d ->
                val offset = d + 1
                val next = (i+offset) % sp.size
                val prev = if(i-offset > -1) i-offset else sp.size + ((i-offset) % sp.size)
                val front = SpringConnection1D(
                    next,
                    p.pos.distanceTo(sp[next].pos)
                )
                val back = SpringConnection1D(
                    prev,
                    p.pos.distanceTo(sp[next].pos)
                )
                if(!skip.contains(offset)){
                    connections.add(front)
                    connections.add(back)
                }
            }
            this.add(connections)
        }
    }
}
